import { render } from "./AppBranding.vue?vue&type=template&id=101c8dfc&scoped=true"
import script from "./AppBranding.vue?vue&type=script&lang=js"
export * from "./AppBranding.vue?vue&type=script&lang=js"

import "./AppBranding.vue?vue&type=style&index=0&id=101c8dfc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101c8dfc"]])

export default __exports__